import * as React from 'react';

function SvgCallMissedOutgoing(props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			height='1em'
			viewBox='0 0 24 24'
			width='1em'
			className='svg-icon'
			{...props}>
			<path d='M0 0h24v24H0z' fill='none' />
			<path d='M19 10.41V15h2V7h-8v2h4.59L12 14.59 4.41 7 3 8.41l9 9z' />
		</svg>
	);
}

export default SvgCallMissedOutgoing;
